import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeModal: {
		id: 'servicedesk-itsm-onboarding-common.benefits-modal.close-modal',
		defaultMessage: 'Close modal',
		description: 'Alt text for cross icon button (with no text) to dismiss a modal',
	},
});
